// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1P8cn","footer":"ReportModalFilter_footer__1rU-p"};